import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import FullScreenLoader from '../../components/FullScreenLoader';
import { remoteRoutes, AUTH_REFRESH_TOKEN_KEY } from '../../data/constants';
import {
  handleLogin,
  handleLogout,
  handleTokenRefreshed,
  startLoading,
  stopLoading,
} from '../../data/coreActions';
import { get, post, getToken } from '../../utils/ajax';

export default function Splash() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(startLoading());
    const finishLoading = () => dispatch(stopLoading());

    // The access token lives 20 minutes, so a page reload after any gap in
    // usage will very often find it expired — try a silent refresh before
    // giving up, so that only doesn't work once the 12h refresh token
    // itself is gone (or invalidated by a newer login elsewhere).
    //
    // Uses /auth/me (the decoded JWT claims — contactId, roles,
    // permissions, fullName, etc.), NOT /auth/profile: that endpoint backs
    // the "My Profile" edit screen and returns a completely different
    // shape with no roles field at all, which silently wiped every user's
    // roles on every cold boot when this was wired to it.
    const fetchProfile = (onFail: () => void) => {
      get(
        remoteRoutes.me,
        (data) => {
          dispatch(handleLogin({ user: data, token: getToken() }));
          finishLoading();
        },
        onFail,
      );
    };

    fetchProfile(() => {
      const refreshToken = localStorage.getItem(AUTH_REFRESH_TOKEN_KEY);
      if (!refreshToken) {
        dispatch(handleLogout());
        finishLoading();
        return;
      }
      post(
        remoteRoutes.refreshToken,
        { refreshToken },
        (refreshData: any) => {
          dispatch(handleTokenRefreshed(refreshData.token));
          fetchProfile(() => {
            dispatch(handleLogout());
            finishLoading();
          });
        },
        () => {
          dispatch(handleLogout());
          finishLoading();
        },
      );
    });
  }, [dispatch]);

  // Shown while the cached session is re-checked on a cold start.
  return <FullScreenLoader />;
}
